import type { HotelSettingsHotelInfoI18nFormModel, ServerModel } from "../../../type";

type Props = {
	serverModel: ServerModel;
};

export const serverModelToInputModel = ({ serverModel }: Props): HotelSettingsHotelInfoI18nFormModel["InputModel"] => {
	const { lang, address, catchCopy, companyID, hotelID, name } = serverModel.hotelI18n;

	const inputModel: HotelSettingsHotelInfoI18nFormModel["InputModel"] = {
		hotelID,
		companyID,
		lang,

		address: {
			nationality: address?.nationality,
			city: address?.city ?? "",
			pref: address?.pref ?? "",
			town: address?.town ?? "",
			other: address?.other,
			postalCode: address?.postalCode,
			state: address?.state,
		},
		catchCopy: catchCopy ?? "",
		name: name ?? "",
	} satisfies HotelSettingsHotelInfoI18nFormModel["InputModel"];

	return inputModel;
};
